<template>
  <div class="container page-container" v-if="dataReady">

    <h1 class="project">{{ project.name }}</h1>
    <p class="edited">Edited: <span class="date">{{prettyDate(project.edited)}}</span><br>
    Created: <span class="date">{{prettyDate(project.created)}}</span></p>

    <div class="add-project" v-if="user.isAdmin">
      <el-form :inline="true" :model="formInline" :label-position="labelPosition" class="form-inline">
        <el-form-item label="Edit Project Name">
          <el-input v-model="project.name" @change="updateName"></el-input>
        </el-form-item>
        <el-form-item label="Add Project Data">
          <input @change="updateFile" type="file" accept=".csv"/>
        </el-form-item>
        <el-form-item label=" ">
          <el-button class="btn-delete" type="primary" @click="deleteFormVisible = true">Delete Project <i class="el-icon-delete el-icon-right"></i></el-button>
        </el-form-item>
      </el-form>
    </div>
    <data-tables
      :data='project.units'
      :actions-def='getExportActionsDef()'
      :pagination-def='getPaginationDef()'
      :search-def='getSearchDef()'
      :has-action-col='false'
      @row-click='rowClick'
      @filtered-data='handleFilterDataChange' v-if="project.units">

      <el-table-column
        prop="unitnum"
        label="Unit No."
        sortable="custom"
        :width="125">
      </el-table-column>

      <!-- <el-table-column
        prop="id"
        label="ID">
      </el-table-column> -->

      <!-- <el-table-column
        prop="floor"
        label="Floor">
      </el-table-column>

      <el-table-column
        prop="unit"
        label="Unit">
      </el-table-column> -->

      <el-table-column
        prop="size"
        label="Size">
      </el-table-column>

      <el-table-column
        prop="size2"
        label="Size 2">
      </el-table-column>

      <el-table-column
        prop="plan"
        label="Plan">
      </el-table-column>

     <el-table-column
        prop="type"
        label="Type"
        :width="450">
      </el-table-column>

      <!-- <el-table-column
        prop="file"
        label="File">
      </el-table-column>

      <el-table-column
        prop="plate"
        label="Plate">
      </el-table-column> -->

      <el-table-column
        prop="price"
        label="Price">
      </el-table-column>

      <el-table-column
        prop="status"
        label="Status">
      </el-table-column>

    </data-tables>

    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <span slot="title" class="dialog-title">
        Edit Unit {{form.unitnum}}
      </span>
      <el-form :model="form" :inline="true" :label-position="labelPosition">
        <!-- <el-form-item label="ID" label-width="50px">
          <el-input v-model="form.id" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Floor">
          <el-input v-model="form.floor" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Unit">
          <el-input v-model="form.unit" auto-complete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="Size" prop="size">
          <el-input v-model="form.size" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Size 2" prop="size2">
          <el-input v-model="form.size2" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="Plan">
          <el-input v-model="form.plan" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Type">
          <el-input v-model="form.file" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Plate">
          <el-input v-model="form.plate" auto-complete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="Price">
          <el-input v-model="form.price" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Status">
          <el-select v-model="form.status">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUpdateUnits()">Cancel</el-button>
        <el-button type="primary" @click="updateUnits">Update</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Are You Sure You Want To Delete This Project?" :visible.sync="deleteFormVisible">
      <el-form :model="form" :inline="true" :label-position="labelPosition">

        <el-button @click="deleteFormVisible = false">No Way, Get Me Out Of Here!</el-button>
        <el-button type="danger" @click="deleteProject()">Delete</el-button>

      </el-form>

    </el-dialog>

  </div>
</template>
<script>
  import CsvExport from '../helpers/CsvExport'
  import Papa from 'PapaParse'
  import moment from 'moment'
  import slugify from 'slugify'
  import lang from 'element-ui/lib/locale/lang/en'
  import locale from 'element-ui/lib/locale'
  import { db, authService } from '../helpers/helpers'
  locale.use(lang)
  var projectRef
  export default {
    name: 'project',
    data () {
      return {
        dataReady: false,
        auth: authService,
        uid: '',
        options: [{
          value: 'Available',
          label: 'Available'
        }, {
          value: 'Held',
          label: 'Held'
        }, {
          value: 'Sold',
          label: 'Sold'
        }, {
          value: 'Future',
          label: 'Future'
        }],
        value: '',
        formInline: {
          user: '',
          unitFile: ''
        },
        // filteredData: [],
        dialogFormVisible: false,
        deleteFormVisible: false,
        labelPosition: 'top',
        form: {
          id: '',
          unitnum: '',
          floor: '',
          unit: '',
          size: '',
          size2: '',
          plan: '',
          type: '',
          file: '',
          plate: '',
          price: '',
          status: '',
          view: ''
        }
      }
    },

    created () {
      this.$bindAsObject('user', db.ref('users').child(this.auth.user.uid))
      projectRef = db.ref(this.$route.path)
      this.$bindAsObject('project', projectRef)
      this.dataReady = true
    },

    methods: {

      deleteProject () {
        this.$firebaseRefs.project.remove()
        this.deleteFormVisible = false
        this.$router.push('/projects')
      },

      prettyDate (date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')
      },

      setDate () {
        let timeStamp = Date.now()
        this.$firebaseRefs.project.child('edited').set(timeStamp)
        this.$firebaseRefs.project.child('mostRecent').set(-Math.abs(timeStamp))
      },

      updateName () {
        let newName = this.project.name
        this.$firebaseRefs.project.child('name').set(newName)
        this.$firebaseRefs.project.child('slug').set(slugify(newName.toLowerCase()))
        this.setDate()
      },

      updateFile (e) {
        var vm = this
        Papa.parse(e.target.files[0], {
          header: true,
          complete (results, file) {
            vm.$firebaseRefs.project.child('units').set(results.data)
            vm.setDate()
          }
        })
        e.target.value = ''
        vm.availPlans()
      },

      handlePreview (file, fileList) {
        console.log(file, 'handle preview')
      },

      handleRemove (file, fileList) {
        console.log(file, fileList)
      },

      handleFilterDataChange (filteredData) {
        this.filteredData = filteredData
      },

      /* getRowActionsDef () {
        let vm = this
        return [{
          handler (row) {
            vm.dialogFormVisible = true
            vm.form = row
          },
          name: 'Edit'
        }]
      }, */

      updateUnits () {
        this.$firebaseRefs.project.child('units').set(this.project.units)
        this.setDate()
        this.dialogFormVisible = false
        this.availPlans()
      },

      availPlans () {
        let units = this.$firebaseRefs.project.child('units')
        let allPlans = new Set()
        let notSoldPlans = new Set()
        // all plans
        units.on('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            var childData = childSnapshot.val()
            allPlans.add(JSON.stringify({'file': childData.file, 'plan': childData.plan, 'size': childData.size, 'size2': childData.size2, 'type': childData.type, 'status': 'Sold'}))
          })
        })
        // not sold plans
        units.on('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            var childData = childSnapshot.val()
            if (childData.status !== 'Sold') {
              notSoldPlans.add(JSON.stringify({'file': childData.file, 'plan': childData.plan, 'size': childData.size, 'size2': childData.size2, 'type': childData.type, 'status': ''}))
            }
          })
        })
        var all = Array.from(allPlans).map(e => JSON.parse(e))
        var notSold = Array.from(notSoldPlans).map(e => JSON.parse(e))
        var clean = all.map(obj => notSold.find(o => o.plan === obj.plan) || obj)
        this.$firebaseRefs.project.child('plans').set(clean)
      },

      cancelUpdateUnits () {
        projectRef = db.ref(this.$route.path)
        this.$bindAsObject('project', projectRef)
        this.dialogFormVisible = false
      },

      getSearchDef () {
        return {
          show: false,
          placeholder: 'Search by Keyword',
          props: ['id', 'unitnum', 'floor', 'unit', 'size', 'size', 'type', 'file', 'plate', 'price', 'status', 'view']
        }
      },

      getPaginationDef () {
        return {
          layout: 'total, prev, pager, next, jumper, sizes',
          pageSize: 300,
          pageSizes: [20, 50, 100, 150, 200, 300],
          currentPage: 1
        }
      },

      getExportActionsDef () {
        let columns = ['id', 'unitnum', 'floor', 'unit', 'size', 'size2', 'plan', 'type', 'file', 'plate', 'price', 'status', 'view']
        let columnNames = ['id', 'unitnum', 'floor', 'unit', 'size', 'size2', 'plan', 'type', 'file', 'plate', 'price', 'status', 'view']

        return {
          width: 19,
          def: [{
            name: 'Export',
            handler: () => {
              let timeStamp = moment(Date.now()).format()
              CsvExport(this.project.units, columns, columnNames, this.project.slug + '_' + timeStamp)
            },
            icon: 'plus'
          }/* , {
            name: 'Export Filtered',
            handler: () => {
              CsvExport(this.filteredData, columns, columnNames, 'filtered')
            },
            icon: 'upload'
          } */]
        }
      },

      rowClick (row) {
        let vm = this
        vm.dialogFormVisible = true
        vm.form = row
      }
    }
  }
</script>

<style>

  h1.project {
    margin-bottom: 0;
  }

  .el-select-dropdown__item {
    font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
  }

  .last-edited,
  .created {
    font-size:  10px;
  }

  .add-button {
    display:  block;
  }

  .pull-left {
    text-indent:  -99999px;
  }

  span.dialog-title {
    font-weight:  600 !important;
  }

  .dialog-footer .el-button {
    margin-bottom: 5px;
  }

  .el-table__row {
    cursor: pointer;
  }

  .el-table__row > td:first-child::before {
    position: absolute;
    content: 'Edit';
    top: 8px;
    font-size: 12px;
    right: 20px;
    color: #13ce66;

    padding: 0 5px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid transparent;
    white-space: nowrap;

    border-color: rgba(18,206,102,.1);
    background-color: rgba(18,206,102,.1);
    display: none;
  }

  .el-table__row:hover > td:first-child::before {
    display: block;
  }

  .btn-delete {
    margin-top: 5px;
  }

</style>



// WEBPACK FOOTER //
// Project.vue?f32e2274